import { SERVER_URL } from '../config'

import { pdfjs } from 'react-pdf'

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`

export const serverFile = (fileName: string) => {
    return fileName && `${SERVER_URL}/file/${fileName}`
}
